import flow from 'lodash/flow';
import withProps from '@atlassian/jira-common-with-props/src/index.tsx';
import CreateButton from '@atlassian/jira-create-dashboards-button/src/index.tsx';
import DashboardsDirectory from '@atlassian/jira-dashboards-main/src/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import DashboardsPage from './view.tsx';

export default flow(injectIntl, withProps({ CreateButton, DashboardsDirectory }))(DashboardsPage);
